// import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Delhitopunetransport() {


const cardData = {


    keyword: "Delhi to Pune Transport Service",

    headingDescription: "Delhi to Pune Transport Service by SSK Logistic is designed for businesses, manufacturers, distributors, traders, retailers, and commercial clients looking for organized goods movement between Delhi and Pune. The service supports regular and project-based transportation of industrial materials, commercial consignments, machinery, packaged goods, cargo, and full truck loads through a planned road transportation network. SSK Logistic coordinates suitable vehicles, loading requirements, route planning, documentation, shipment handling, and delivery schedules to make Delhi to Pune goods movement more systematic. With options for truck transport, container transport, freight movement, logistics support, and cargo booking, businesses can manage interstate transportation requirements with better coordination from pickup to final delivery.",

    topPlaces: [
        {
            title: "Pune",
            description: "Pune serves as a major commercial and industrial destination for consignments arriving from Delhi, supporting manufacturing units, distributors, warehouses, retailers, and corporate supply chains. SSK Logistic coordinates Delhi to Pune transportation for different cargo volumes and delivery requirements."
        },
        {
            title: "Moshi",
            description: "Moshi has developed into an important residential, commercial, and warehousing zone on the northern side of Pune. Delhi-origin goods can be coordinated toward Moshi for businesses requiring organized road transportation, warehouse deliveries, commercial consignments, and distribution support."
        },
        {
            title: "Pirangut",
            description: "Pirangut is surrounded by industrial and manufacturing activity, making it relevant for transportation of machinery, raw materials, finished products, and commercial cargo. SSK Logistic supports Delhi to Pirangut movement with planned truck and freight transportation arrangements."
        },
        {
            title: "Delhi to Khed City",
            description: "Delhi to Khed City transportation can support industrial units and commercial establishments located along Pune's northern industrial belt. The route can be coordinated for machinery, production materials, packaged goods, and other business consignments requiring dependable road movement."
        },
        {
            title: "Jejuri",
            description: "Jejuri is connected with industrial and manufacturing activity in the broader Pune region and can be served through organized interstate freight movement. SSK Logistic helps coordinate Delhi-origin cargo toward Jejuri according to vehicle capacity, shipment type, and delivery requirements."
        },
        {
            title: "Daund",
            description: "Daund acts as an important regional connectivity point for industrial, agricultural, and commercial movement around eastern Pune. Delhi to Daund transportation can accommodate bulk goods, commercial materials, machinery, and business consignments requiring long-distance road logistics."
        },
        {
            title: "Delhi to Kurkumbh",
            description: "Delhi to Kurkumbh transportation is suitable for industrial consignments associated with the manufacturing and chemical-industrial belt around Pune. SSK Logistic can coordinate appropriate freight vehicles and transportation schedules for businesses moving materials over the interstate route."
        },
        {
            title: "Sanaswadi",
            description: "Sanaswadi is located along an active industrial corridor near Pune and supports manufacturing, warehousing, and commercial operations. Transportation from Delhi to Sanaswadi can be arranged for factory supplies, finished goods, machinery, and other cargo requiring structured road delivery."
        },
        {
            title: "Delhi to Shikrapur",
            description: "Delhi to Shikrapur movement connects northern Pune's industrial and commercial areas with the national capital region. The route can be utilized for transporting equipment, raw materials, packaged products, commercial inventory, and full truck load consignments."
        },
        {
            title: "Wagholi",
            description: "Wagholi has grown as a major eastern Pune commercial and logistics zone with connections toward industrial areas, warehouses, and distribution networks. SSK Logistic supports Delhi-origin consignments reaching Wagholi through suitable truck, cargo, container, and freight transportation solutions."
        }
    ],

    "services": [
        {
            "name": "delhi to pune transport service",
            "description": "The delhi to pune transport service from SSK Logistic supports businesses requiring structured interstate movement of goods between the Delhi region and Pune. Vehicle selection, pickup coordination, route planning, loading requirements, and destination delivery can be organized according to the nature and volume of the shipment."
        },
        {
            "name": "delhi to pune transportation service",
            "description": "SSK Logistic manages delhi to pune transportation service requirements for manufacturers, suppliers, distributors, traders, and commercial establishments. The service is designed around planned road movement, suitable vehicle allocation, shipment coordination, and delivery scheduling for different types of commercial consignments."
        },
        {
            "name": "delhi pune goods transport",
            "description": "Delhi pune goods transport is suitable for moving packaged products, industrial materials, machinery, commercial inventory, equipment, and other business cargo. SSK Logistic coordinates the transportation process with attention to vehicle capacity, loading arrangements, route requirements, and destination handling."
        },
        {
            "name": "delhi to pune goods transportation",
            "description": "The delhi to pune goods transportation service helps businesses move consignments across the long-distance interstate route through organized road logistics. SSK Logistic can coordinate transportation according to cargo dimensions, quantity, vehicle requirements, loading points, and final delivery locations in the Pune region."
        },
        {
            "name": "delhi to pune cargo transport",
            "description": "Delhi to pune cargo transport is arranged for companies that need dependable movement of commercial and industrial shipments from Delhi toward Pune. SSK Logistic supports cargo planning, vehicle coordination, loading supervision, route management, and delivery scheduling for different shipment categories."
        },
        {
            "name": "delhi to pune freight transport",
            "description": "Businesses requiring delhi to pune freight transport can use SSK Logistic for planned interstate freight movement involving raw materials, finished products, machinery, equipment, and commercial cargo. Transportation arrangements can be aligned with shipment volume, vehicle capacity, and delivery requirements."
        },
        {
            "name": "delhi to pune logistics service",
            "description": "The delhi to pune logistics service combines road transportation coordination with shipment planning for businesses moving goods between two major commercial regions. SSK Logistic helps organize pickup, vehicle allocation, freight movement, destination delivery, and other transportation-related requirements."
        },
        {
            "name": "delhi pune transport company",
            "description": "SSK Logistic functions as a delhi pune transport company for businesses seeking coordinated road transportation between Delhi and Pune. The service can support regular consignments, commercial deliveries, industrial materials, bulk shipments, and full-load transportation according to operational requirements."
        },
        {
            "name": "delhi to pune truck transport",
            "description": "Delhi to pune truck transport provides a practical road movement option for large and medium-sized commercial consignments. SSK Logistic coordinates suitable trucks according to cargo quantity, dimensions, loading requirements, and destination conditions for planned interstate delivery."
        },
        {
            "name": "delhi to pune full truck load transport",
            "description": "For businesses moving larger consignments, delhi to pune full truck load transport allows dedicated vehicle capacity to be allocated for a shipment. SSK Logistic coordinates FTL movement for industrial goods, commercial inventory, machinery, raw materials, and other suitable cargo requiring direct transportation."
        },
        {
            "name": "delhi to pune container transport",
            "description": "Delhi to pune container transport is suitable for businesses handling standardized, protected, bulk, or industrial consignments that require containerized road movement. SSK Logistic coordinates appropriate container vehicles based on cargo volume, loading conditions, route requirements, and destination delivery needs."
        },
        {
            "name": "delhi to pune commercial transport",
            "description": "The delhi to pune commercial transport service supports retailers, distributors, wholesalers, manufacturers, and other businesses transporting inventory between Delhi and Pune. Shipment planning can cover commercial goods, packaged products, equipment, supplies, and other business-related cargo."
        },
        {
            "name": "delhi to pune industrial transport",
            "description": "Delhi to pune industrial transport is designed for factories and industrial businesses moving machinery, production materials, equipment, components, and finished goods. SSK Logistic coordinates vehicle requirements and road transportation planning around the specific nature and scale of industrial cargo."
        },
        {
            "name": "delhi to pune cargo transportation",
            "description": "The delhi to pune cargo transportation service helps businesses coordinate long-distance movement of commercial shipments from Delhi toward Pune. SSK Logistic can arrange suitable transportation resources for different cargo sizes while maintaining planned pickup, transit, and delivery coordination."
        },
        {
            "name": "delhi to pune freight services",
            "description": "Delhi to pune freight services are useful for companies that regularly move goods between northern and western India. SSK Logistic supports freight planning for commercial and industrial consignments, with transportation arrangements based on shipment type, load quantity, vehicle availability, and delivery location."
        },
        {
            "name": "delhi to pune goods transport company",
            "description": "Businesses searching for a delhi to pune goods transport company can use SSK Logistic for organized interstate road movement. The service supports manufacturers, suppliers, distributors, and traders requiring transportation of goods, materials, inventory, equipment, and other commercial consignments."
        },
        {
            "name": "delhi to pune transport company",
            "description": "The delhi to pune transport company service from SSK Logistic focuses on coordinated road transportation for businesses operating between Delhi and Pune. Pickup planning, truck allocation, cargo movement, route coordination, and destination delivery can be managed according to shipment requirements."
        },
        {
            "name": "delhi to pune transporters",
            "description": "Delhi to pune transporters support businesses that need road vehicles for moving goods across the interstate corridor. SSK Logistic coordinates transportation requirements for different cargo categories, helping clients arrange suitable vehicle capacity and planned delivery toward Pune."
        },
        {
            "name": "delhi to pune logistics provider",
            "description": "As a delhi to pune logistics provider, SSK Logistic supports businesses with organized freight and road transportation coordination between the two regions. Services can be structured around pickup locations, cargo specifications, truck requirements, route planning, and final delivery destinations."
        },
        {
            "name": "delhi to pune road transport",
            "description": "Delhi to pune road transport offers a flexible solution for businesses moving commercial goods and industrial materials over a long-distance interstate route. SSK Logistic coordinates suitable road vehicles and shipment schedules according to cargo volume, loading requirements, and destination delivery needs."
        },
        {
            "name": "delhi to pune safe goods transport",
            "description": "The delhi to pune safe goods transport service focuses on planned handling and transportation of business consignments from pickup through road transit to delivery. SSK Logistic considers cargo type, packaging, vehicle suitability, loading arrangements, and destination requirements while coordinating transportation."
        },
        {
            "name": "delhi to pune reliable transport service",
            "description": "Businesses needing a delhi to pune reliable transport service can coordinate their interstate shipments with SSK Logistic. The service is structured around clear pickup planning, suitable vehicle selection, shipment coordination, route management, and scheduled delivery for commercial and industrial cargo."
        },
        {
            "name": "delhi to pune truck booking",
            "description": "Delhi to pune truck booking helps businesses arrange suitable truck capacity before dispatching their consignments. SSK Logistic coordinates vehicle requirements based on load size, cargo category, loading location, and destination so that transportation can be planned more efficiently."
        },
        {
            "name": "delhi to pune cargo booking",
            "description": "The delhi to pune cargo booking service enables businesses to plan interstate movement of commercial and industrial consignments through suitable road transportation arrangements. SSK Logistic assists with shipment details, vehicle coordination, pickup planning, and destination delivery requirements."
        }
    ],

    "tableData": [
        ["delhi to pune transport service", "delhi to pune transportation service"],
        ["delhi pune goods transport", "delhi to pune goods transportation"],
        ["delhi to pune cargo transport", "delhi to pune freight transport"],
        ["delhi to pune logistics service", "delhi pune transport company"],
        ["delhi to pune truck transport", "delhi to pune full truck load transport"],
        ["delhi to pune container transport", "delhi to pune commercial transport"],
        ["delhi to pune industrial transport", "delhi to pune cargo transportation"],
        ["delhi to pune freight services", "delhi to pune goods transport company"],
        ["delhi to pune transport company", "delhi to pune transporters"],
        ["delhi to pune logistics provider", "delhi to pune road transport"],
        ["delhi to pune safe goods transport", "delhi to pune reliable transport service"],
        ["delhi to pune truck booking", "delhi to pune cargo booking"],
        ["Delhi to Pune Transport Service", "Interstate Goods Transportation"]
    ],

    whychoose: [
        {
            WhyChooseheading: "Dedicated Interstate Route Planning",
            WhyChoosedescription: "SSK Logistic coordinates Delhi to Pune transportation with route planning suited to the shipment type, pickup location, vehicle capacity, and delivery destination. This structured approach helps businesses organize long-distance road movement with clearer transportation schedules."
        },
        {
            WhyChooseheading: "Suitable Vehicles for Different Loads",
            WhyChoosedescription: "Different consignments require different vehicle capacities and configurations. Transportation arrangements can be planned according to cargo dimensions, weight, volume, packaging, and loading conditions so businesses can select a practical vehicle for their Delhi to Pune movement."
        },
        {
            WhyChooseheading: "Support for Industrial Shipments",
            WhyChoosedescription: "Manufacturing and industrial businesses can coordinate transportation for machinery, raw materials, components, equipment, and finished products. SSK Logistic structures the movement around the operational requirements associated with larger and specialized commercial consignments."
        },
        {
            WhyChooseheading: "Full Load Transportation Coordination",
            WhyChoosedescription: "For larger consignments, full truck load movement provides dedicated vehicle capacity for a planned shipment. SSK Logistic coordinates FTL transportation from Delhi toward Pune based on cargo volume, loading requirements, route planning, and delivery schedules."
        },
        {
            WhyChooseheading: "Organized Cargo Handling",
            WhyChoosedescription: "Cargo movement requires coordination at multiple stages, including pickup, loading, road transit, and destination delivery. SSK Logistic keeps these transportation activities organized around the shipment details supplied by the business."
        },
        {
            WhyChooseheading: "Commercial and Business-Focused Movement",
            WhyChoosedescription: "The Delhi to Pune corridor serves manufacturers, wholesalers, distributors, retailers, and other commercial operations. Transportation arrangements can be adapted for recurring business consignments, inventory transfers, industrial supplies, and distribution requirements."
        },
        {
            WhyChooseheading: "Flexible Booking Requirements",
            WhyChoosedescription: "Truck and cargo booking can be planned around different shipment quantities and delivery locations. SSK Logistic helps businesses coordinate vehicle requirements for individual consignments as well as recurring transportation needs along the Delhi to Pune route."
        },
        {
            WhyChooseheading: "Planned Delivery Coordination",
            WhyChoosedescription: "Long-distance transportation benefits from clear coordination between pickup and destination teams. SSK Logistic manages transportation planning around shipment information, vehicle allocation, route requirements, and delivery locations to support a more systematic Delhi to Pune logistics process."
        }
    ]

};















const faqData = [
    {
        question: "What does SSK Logistic provide for Delhi to Pune transport service?",
        answer: "SSK Logistic assists businesses with interstate goods transportation from Delhi to Pune, coordinating suitable commercial vehicles according to cargo type, shipment quantity, weight, loading requirements, pickup location, delivery point, and preferred schedule."
    },
    {
        question: "Can SSK Logistic transport commercial inventory from Delhi to Pune?",
        answer: "Commercial inventory, packaged products, raw materials, machinery, equipment, components, business supplies, and other suitable goods can be transported from Delhi to Pune based on the shipment specifications and required vehicle capacity."
    },
    {
        question: "Can industrial machinery be moved from Delhi to Pune?",
        answer: "Industrial machinery, manufacturing equipment, components, materials, and other suitable commercial cargo can be considered for Delhi to Pune transportation after reviewing the shipment weight, dimensions, loading conditions, and vehicle requirements."
    },
    {
        question: "Does SSK Logistic arrange regular Delhi to Pune transportation?",
        answer: "Companies with recurring interstate movement requirements can discuss regular transportation arrangements based on shipment frequency, cargo volume, pickup locations, delivery destinations, vehicle capacity, and their business operating schedule."
    },
    {
        question: "Which Delhi areas can be covered for Pune-bound shipments?",
        answer: "Pickup arrangements can be discussed from commercial and industrial locations across Delhi and nearby business areas, including Okhla, Bawana, Naraina, Wazirpur, Mayapuri, Patparganj, and other suitable pickup locations."
    },
    {
        question: "What type of vehicle is suitable for Delhi to Pune goods transportation?",
        answer: "Vehicle selection depends on cargo weight, dimensions, quantity, loading method, material characteristics, and delivery requirements. SSK Logistic can review the shipment specifications and discuss suitable commercial vehicle options."
    },
    {
        question: "Can warehouse-to-warehouse transportation be arranged from Delhi to Pune?",
        answer: "Warehouse-to-warehouse movement can be coordinated for businesses transferring inventory, finished products, raw materials, equipment, or other commercial cargo between warehouses, distribution centers, manufacturing units, and business locations."
    },
    {
        question: "Can SSK Logistic handle bulk shipments from Delhi to Pune?",
        answer: "Bulk transportation requirements can be discussed by sharing the total cargo quantity, approximate weight, number of consignments, Delhi loading location, Pune delivery address, vehicle requirement, and preferred movement schedule."
    },
    {
        question: "How does SSK Logistic plan long-distance Delhi to Pune transportation?",
        answer: "The transportation plan considers the complete pickup and delivery addresses, cargo type, shipment quantity, weight and dimensions, loading requirements, vehicle capacity, route considerations, and expected delivery timeline before arranging the interstate movement."
    },
    {
        question: "What information is needed for a Delhi to Pune transport enquiry?",
        answer: "Businesses can provide the Delhi pickup address, Pune delivery location, cargo description, approximate weight or quantity, dimensions if applicable, loading details, vehicle preference, and preferred pickup or delivery schedule for transportation planning."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Rohit Bansal",
        feedback: "We needed to transport commercial stock from Delhi to our Pune facility and wanted the interstate movement carefully coordinated. SSK Logistic understood our shipment requirements and helped organize the transportation according to our planned schedule.",
        rating: 5
    },
    {
        id: 2,
        name: "Miss. Simran Kapoor",
        feedback: "Our company had equipment and business materials that needed to travel from Delhi to Pune. The SSK Logistic team reviewed the cargo details and vehicle requirements clearly, making the long-distance transportation coordination convenient for us.",
        rating: 5
    }
];






    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Logistics Company Pune",
            link: "Logistics-Company-Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Best Logistics Companies in Pune",
            link: "Best-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Top Logistics Companies in Pune",
            link: "Top-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Logistics in Pune",
            link: "Logistics-in-Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Transport Company in Pune",
            link: "Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Logistics Companies in Pune",
            link: "Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Transporters in Pune",
            link: "Transporters-in-Pune",
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Transport Office",
            link: "Pune-Transport-Office",
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Best Logistics Company in Pune",
            link: "Best-Logistics-Company-in-Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Goods Transport Services in Pune",
            link: "Goods-Transport-Services-in-Pune",
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Transportation Services for Industrial",
            link: "Transportation-Services-for-Industrial",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune Transport Service for Company",
            link: "Pune-Transport-Service-for-Company",
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Industrial Transport Company in Pune",
            link: "Industrial-Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Supply Chain Management Company in Pune",
            link: "Supply-Chain-Management-Company-in-Pune",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Cargo Transportation Company in Pune",
            link: "Cargo-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Commercial Transportation Services in Pune",
            link: "Commercial-Transportation-Services-in-Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Container Transportation Company in Pune",
            link: "Container-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Third Party Logistics Company in India",
            link: "Third-Party-Logistics-Company-in-India",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Transport Service",
            link: "Pune-to-Mumbai-Transport-Service",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune to Bangalore Transport Service",
            link: "Pune-to-Bangalore-Transport-Service",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Hyderabad Transport Service",
            link: "Pune-to-Hyderabad-Transport-Service",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Chennai Transport Service",
            link: "Pune-to-Chennai-Transport-Service",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Delhi Transport Service",
            link: "Pune-to-Delhi-Transport-Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Ahmedabad Transport Service",
            link: "Pune-to-Ahmedabad-Transport-Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Surat Transport Service",
            link: "Pune-to-Surat-Transport-Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Nashik Transport Service",
            link: "Pune-to-Nashik-Transport-Service",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Nagpur Transport Service",
            link: "Pune-to-Nagpur-Transport-Service",
        },
        {
            place: "/images/keyword/28.jpg",
            text: "Pune to Kolhapur Transport Service",
            link: "Pune-to-Kolhapur-Transport-Service",
        },
    ];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Delhi to Pune Transport Service",
  "image": "https://ssklogistics.in/assets/images/delhi-to-pune-transport-service.webp",
  "description": "SSK Logistics provides Delhi to Pune Transport Service for businesses requiring dependable interstate movement of goods, cargo, freight and commercial consignments between Delhi and Pune. Delhi to Pune transport service can support manufacturers, distributors, wholesalers, retailers, warehouses, suppliers and industrial businesses that require regular, scheduled or project-based transportation across North and West India. Delhi to Pune transportation service can be coordinated according to cargo type, shipment volume, vehicle capacity, pickup requirements and delivery schedules. Delhi Pune goods transport can cover commercial products, industrial materials, packaged goods, machinery, equipment, inventory and other business consignments. Delhi to Pune goods transportation can support supplier deliveries, warehouse transfers, stock movement, distribution requirements and recurring commercial shipments along the route. Delhi to Pune cargo transport is suitable for commercial and industrial cargo requiring organized road transportation, while Delhi to Pune freight transport can accommodate larger consignments and recurring business freight requirements. Delhi to Pune logistics service can include vehicle coordination, route planning, pickup scheduling and delivery coordination according to individual shipment requirements. SSK Logistics can arrange dedicated vehicles, full truck load transportation and suitable road transport solutions for businesses moving goods between Delhi and Pune. Delhi Pune transport company requirements can be supported with flexible vehicle planning for different cargo volumes, shipment sizes and delivery schedules. Delhi to Pune truck transport can handle suitable commercial consignments through planned road transportation, while Delhi to Pune full truck load transport can support larger shipments requiring dedicated vehicle capacity. The service can connect factories, warehouses, suppliers, distribution centers, retailers and customer destinations across Delhi, Pune and surrounding industrial areas. SSK Logistics focuses on organized Delhi to Pune goods, cargo and freight transportation designed around cargo specifications, business schedules and destination requirements.",
  "brand": {
    "@type": "Brand",
    "name": "SSK Logistics"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Contact for Transport Service Pricing",
    "availability": "https://schema.org/InStock",
    "url": "https://ssklogistics.in/delhi-to-pune-transport-service"
  }
};



    return (
        <div>
<Helmet>
  <title>
    Delhi to Pune Transport Service | Goods, Cargo, Freight & Full Truck Load Transport | +91 9876543210
  </title>

  <meta
    name="description"
    content="SSK Logistics provides Delhi to Pune transport services for goods, cargo, freight and full truck load shipments with coordinated interstate road transportation solutions."
  />

  <meta
    name="keywords"
    content="Delhi to Pune Transport Service, Delhi to Pune transport service, Delhi to Pune transportation service, Delhi Pune goods transport, Delhi to Pune goods transportation, Delhi to Pune cargo transport, Delhi to Pune freight transport, Delhi to Pune logistics service, Delhi Pune transport company, Delhi to Pune truck transport, Delhi to Pune full truck load, Delhi Pune transportation service, Delhi Pune goods transportation, Delhi Pune cargo transportation, Delhi Pune freight services, Delhi to Pune transport company, Delhi to Pune goods transport company, Delhi to Pune cargo transport company, Delhi to Pune freight transportation, Delhi to Pune logistics company, Delhi Pune logistics services, Delhi Pune commercial transport, Delhi Pune commercial goods transport, Delhi Pune industrial transport, Delhi Pune industrial goods transportation, Delhi Pune truck transportation, Delhi Pune full truck load transport, Delhi to Pune FTL transport, Delhi Pune cargo services, Delhi Pune goods transportation services, Delhi Pune freight transportation services, Delhi Pune road transport, Delhi to Pune road transportation, Delhi Pune business transport, Delhi Pune warehouse transport, Delhi Pune commercial logistics, Delhi Pune supply chain transportation, Delhi Pune dedicated truck transport, Delhi Pune dedicated transportation, Delhi Pune interstate goods transport, Delhi to Pune commercial truck service, Delhi to Pune dedicated truck service, Delhi Maharashtra goods transportation"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>








            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/35.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >SSK Logistics
                                : {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="cab-service-list">
                                {cardData.services.map((service, index) => (
                                    <div className="cab-service-row" key={index}>
                                        <div className="cab-service-details">
                                            <h4>{service.name}</h4>
                                            <span className="cab-service-line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="cab-service-arrow">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div> */}
                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>


                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>SSK Logistics</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">




                                        <div className="row twm-faq-section-1 m-b30">


                                            <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                                <div className="twm-faq-info-wrap">

                                                    <div className="section-head left">
                                                        <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For SSK Logistics </h2>
                                                    </div>


                                                    <div className="twm-faq-info">
                                                        <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                            <FaqSection
                                                                title=""
                                                                subtitle=""
                                                                items={faqData}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919876543210 " className="pc-call">+91 9876543210 </a>
                                        </div>


                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919876543210 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919876543210 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:info@ssklogistics.in" className="pc-email">
                                            info@ssklogistics.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>SSK Logistics</strong><br />
                                            ViOffice no. 109 first Floor, Ashoka Plaza, above dominos Pizza, Beside Hyatt Hotel, Viman Nagar, Pune- 411014




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Delhitopunetransport;